import { css } from "@emotion/react";

import Container from "@/components/Container/Container";
import { H2 } from "@/components/Typography";
import HelpIcon from "@/svg/HelpIcon";
import { darkColor } from "@/constants/colors";
import FAQItem from "./FAQ/FAQItem";
import { mq } from "@/constants/breakpoints";
import { useMemo } from "react";

const COLUMNS = 2;

interface PageFAQSectionProps {
  faqItems: any;
}

const PageFAQSection: React.FC<PageFAQSectionProps> = ({ faqItems: items }) => {
  const itemsPerColumn = useMemo(() => Math.ceil(items.length / COLUMNS), [
    items,
  ]);

  const faqItems = useMemo(
    () =>
      items.map((item: any) => ({
        question: item.question,
        answer: item.answer.json || item.answer,
      })),
    [items]
  );

  return (
    <Container>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          gap: 40px;
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 20px;
            flex-wrap: nowrap;
          `}
        >
          <div
            css={css`
              width: 60px;
              height: 60px;
              border-radius: 50%;
              background: #def3ff;
              display: none;
              justify-content: center;
              align-items: center;
              flex-shrink: 0;
              ${mq["sm"]} {
                display: flex;
              }
            `}
          >
            <HelpIcon width={24} height={24} color="#048CDD" />
          </div>
          <H2
            // level={2}
            css={css`
              color: ${darkColor};
              text-align: left;
              font-size: 28px;
              ${mq["lg"]} {
                font-size: 50px;
                line-height: 65.01px;
                text-align: left;
              }
            `}
          >
            Frequently Asked Questions
          </H2>
        </div>
        <div
          css={css`
            display: flex;
            flex-direction: row;
            gap: 80px;
            @media (max-width: 768px) {
              flex-direction: column;
              gap: 40px;
            }
          `}
        >
          {[...Array(COLUMNS)].map((_, columnIndex) => (
            <div
              key={columnIndex}
              css={css`
                flex: 1;
                display: flex;
                flex-direction: column;
              `}
            >
              {faqItems
                .slice(
                  columnIndex * itemsPerColumn,
                  (columnIndex + 1) * itemsPerColumn
                )
                .map((item: any, index: number) => (
                  <FAQItem
                    key={index}
                    question={item.question}
                    answer={item.answer}
                  />
                ))}
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default PageFAQSection;
